import type { components, paths } from "@/api/schema.ts";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/ky.ts";
import { getApiUrl } from "@/api/utils.ts";

export const MERCHANT_CONFIG_KEY = "merchantConfig";

type MerchantConfigurationParams = paths["/merchants/merchant/{merchantId}/configuration"]["get"]["parameters"]["path"];
type MerchantConfigurationResponse = components["schemas"]["MerchantConfiguration"];

export function useMerchantConfigurationQuery(
  params: MerchantConfigurationParams,
  options?: Omit<UseQueryOptions<MerchantConfigurationResponse, HTTPError>, "queryFn" | "queryKey">,
) {
  return useQuery<MerchantConfigurationResponse, HTTPError>({
    queryKey: [MERCHANT_CONFIG_KEY, params],
    queryFn: () => api.get(getApiUrl("/merchants/merchant/{merchantId}/configuration", params)).json(),
    ...options,
  });
}
